module.exports = __webpack_public_path__ + "img/sol_cap4.6b7cde2b.png";